import React from 'react'

import Locale from '../locale'
import PurposeVendorList from '../PurposeVendorList'


export default function makePurposeDetails({ purpose, vendors }) {
  // Each `content`' has to be an array of the type specified by
  // ContentMessage.propTypes.message
  return [
    {
      header: Locale.description,
      content: [purpose.description],
    },
    {
      header: Locale.example,
      content: purpose.illustrations,
    },
    {
      header: Locale.vendorsRequestingContent,
      content: [
        <PurposeVendorList
          key="vendorList"
          vendors={ vendors }
        />,
      ],
    },
  ]
}
